// Toasts can contain server error text as well as the existing account links.
// Rebuild a small set of inert elements; never insert the supplied nodes or
// carry over attributes, styles, images, handlers, or executable URLs.
export function toastHtml(message) {
  const source = document.createElement("template");
  source.innerHTML = String(message ?? "");
  const output = document.createElement("span");
  const allowedTags = new Set(["A", "B", "STRONG", "EM", "I", "BR"]);

  const append = (parent, node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      parent.appendChild(document.createTextNode(node.textContent));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (!allowedTags.has(node.tagName)) {
      parent.appendChild(document.createTextNode(node.textContent));
      return;
    }

    const element = document.createElement(node.tagName.toLowerCase());
    if (node.tagName === "A") {
      try {
        const href = new URL(node.getAttribute("href") || "", window.location.origin);
        // These notices only need links within the app.
        if (href.origin === window.location.origin && ["http:", "https:"].includes(href.protocol)) {
          // Keep the absolute URL: a path beginning // would otherwise become
          // a protocol-relative link to a different host when inserted again.
          element.setAttribute("href", href.href);
        }
      } catch (_) {
        // Invalid links remain readable text.
      }
    }
    for (const child of node.childNodes) append(element, child);
    parent.appendChild(element);
  };

  for (const node of source.content.childNodes) append(output, node);
  return output.innerHTML;
}
